export const USER_LEVELS = {
  DEFAULT: 0,        // Default user level with minimal permissions
  SUPERUSER: 5,      // Superuser with extensive permissions
  ADMIN: 1111        // Administrator with full system access
}
